// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ClearoptionsController from "./clearoptions_controller"
application.register("clearoptions", ClearoptionsController)

import FilterController from "./filter_controller"
application.register("filter", FilterController)

import FocusController from "./focus_controller"
application.register("focus", FocusController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import LabelrowsController from "./labelrows_controller"
application.register("labelrows", LabelrowsController)

import LettersController from "./letters_controller"
application.register("letters", LettersController)

import MapController from "./map_controller"
application.register("map", MapController)

import MarkupController from "./markup_controller"
application.register("markup", MarkupController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NestedRondoController from "./nested_rondo_controller"
application.register("nested-rondo", NestedRondoController)

import PrintController from "./print_controller"
application.register("print", PrintController)

import TextController from "./text_controller"
application.register("text", TextController)

import TransferController from "./transfer_controller"
application.register("transfer", TransferController)

import ValidationController from "./validation_controller"
application.register("validation", ValidationController)

